// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1O8c4","errors":"Errors_errors__1Nxi6"};